<template>
<div id="app">
<router-view/>
</div>
</template>
<script>
export default {
  name: 'App',
  created:function(){
    window.axios.interceptors.response.use(undefined, function(err) {
            return new Promise(function() {
                if (err.response.status == 401 && err.response.config && !err.response.config.__isRetryRequest) {
                  localStorage.removeItem('token_empire_token_identifyer')
                  localStorage.removeItem('username')
                  delete window.axios.defaults.headers.common['Authorization']
                  window.Fire.$emit('logout')
                  this.$router.push('/login')
                }
                throw err;
            })
        })
  },
  mounted(){
    window.Fire.$on('logout',()=>{
      this.$router.push('/login')
    })
  }
}
</script>
<style lang="scss">
.popover {
      position: absolute !important;
    top: 0px !important;
    left: 90px !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
color: #2c3e5077;
background-color:#d7d8da6b;
}
.modal-content{
 /* background: linear-gradient(to right, #570827,#2b0112) !important;*/
 background: #203a43 
 !important;

  color:white !important;
}
.modal-footer{
  display:none !important;
}
.modal-header{
  display:none !important;
}

.bg-gradient-danger {
  -webkit-transition: all .25s ease;
  -o-transition: all .25s ease;
  -moz-transition: all .25s ease;
  transition: all .25s ease;
  border:0 !important;
  background-color: #28a745 !important;
        
}
.buy-now .btn-buy-now {
    position: fixed !important;
    bottom: 3rem !important;
    right: 1.625rem !important;
    z-index: 999999 !important;
    box-shadow: 0 1px 20px 1px #ff3e1d !important;
}
.btn-danger {
    color: #fff !important;
    background-color: #ff3e1d !important;
    border-color: #ff3e1d !important;
    box-shadow: 0 0.125rem 0.25rem 0 #2b0112 !important;
    
}
.badge-success {
    border: 1px solid #1bcfb4 !important;
    background: #1bcfb4 !important;
    color: #ffffff !important;
}
.btn-primary {
    color: #fff !important;
    background-color: #696cff !important;
    border-color: #696cff !important;
    box-shadow: 0 0.125rem 0.25rem 0 rgba(130, 132, 223, 0.4) !important;
}
.slick-arrow.slick-prev::before{
  color:rgb(4,96,130); 
}
.slick-arrow.slick-next::before{
  color:rgb(4,96,130); 
}
.dropdown  .btn-secondary{
background: transparent !important;
color:black;
border:0 !important;
}
.modal-body {
    position: relative;
    flex: 1 1 auto;
     padding: 0 !important; 
}
.modal-content{
  border-radius: 10px !important;
}
.bg-gradient-danger-header {
  -webkit-transition: all .25s ease;
  -o-transition: all .25s ease;
  -moz-transition: all .25s ease;
  transition: all .25s ease;
  border:0 !important;
    background: -webkit-gradient(linear, left top, right top, from(#e4f359), color-stop(99%, gold)) !important;
        background: linear-gradient(to right, rgba(10, 10, 10, 0.842), rgba(0, 0, 0, 0.897) 50%) !important;
}

th{
  font-weight: bolder !important;
  font-size: large !important;
  background: linear-gradient(90deg, #004d40, #00695c) !important;
  color: white !important;
  
}
/* Base row styling */
tbody tr {
  transition: all 0.3s ease-in-out !important;
  overflow: hidden !important;
  border:0 !important;
  border-radius: 8px;
  margin-bottom: 6px;
  overflow: hidden;
}

/* Hover effect */
tbody tr:hover {
  background: rgba(79, 195, 247, 0.1) !important; /* light blue tint */
  transform: scale(1.01) !important; /* slight zoom */
  box-shadow: 0 4px 15px rgba(79, 195, 247, 0.3) !important; /* soft glow */
  z-index: 2 !important;
  width: 100% !important;
  position: relative !important;
  cursor: pointer !important;
}



</style>
